import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { TranslateModule } from '@ngx-translate/core';
// import { FooterComponent } from '@zshared/components/footer/footer.component';
// import { HeaderComponent } from '@zshared/components/header/header.component';
// import { SidebarComponent } from '@zshared/components/sidebar/sidebar.component';
// import { SharedModule } from '@zshared/shared.module';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSpinModule } from 'ng-zorro-antd/spin';
// import { HomeLayoutComponent } from './home/home.layout.component';
// import { ErrorLayoutComponent, MasterLayoutComponent } from '.';
// import { HomeLayoutComponent } from './home/home.layout.component';

// Note we need a separate function as it's required
// by the AOT compiler.

@NgModule({
    imports: [
        NzCollapseModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NzIconModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzAvatarModule,
        NzInputModule,
        NzButtonModule,
        NzSpinModule,
        NzDrawerModule,
        NzCardModule,
        NzModalModule,
        NzImageModule,
        NzPopoverModule,
        // TranslateModule.forChild(),
        // SharedModule
    ],
    declarations: [
        // MasterLayoutComponent,
        // HomeLayoutComponent,
        // ErrorLayoutComponent,
        // HeaderComponent,
        // SidebarComponent,
        // FooterComponent
    ],
    providers: []
})
export class LayoutModule {}
